import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { awardBadge, awardBadgeFail, awardBadgeSuccess, fetchAvailableBadges, fetchAvailableBadgesSuccess, fetchBadgeGiverStreamNext, awardingBadge } from './actionCreators';
import { getIsMobile } from '../../publicSession/selectors';
import { removeModalsOfType } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import { getCommentNotificationQueue } from '../../Comment/utils';
import { withOffset, selectors as streamSelectors } from '../../Stream';
import { DeviationResourceType } from '../../types/deviation';
import { ResourceType } from '../../types/resource';
import { getIsAwarding } from './selectors';
function getFakeStreamData() {
    if (process.env.NODE_ENV !== 'production') {
        const { users } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance } = require('chance'); // eslint-disable-line global-require
        const chance = new Chance();
        return {
            hasMore: false,
            nextOffset: null,
            results: chance.pickset(users, 20).map((user)=>_object_spread_props(_object_spread({}, user), {
                    isWatching: chance.bool(),
                    profile: {
                        tagline: chance.bool() ? chance.sentence() : ''
                    }
                }))
        };
    }
    return false;
}
function* handleAwardBadge(action) {
    const { badgeType, recipient } = action.payload;
    const isAwarding = yield select(getIsAwarding);
    if (isAwarding) {
        return;
    }
    const data = {
        badgetype: badgeType,
        typeid: recipient.typeId,
        itemid: recipient.itemId,
        userid: recipient.user.userId
    };
    yield put(awardingBadge());
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'corebadge/award',
        data
    });
    if (result && result.badge) {
        // Close the modal first
        yield put(removeModalsOfType(ModalType.AWARD_BADGE));
        const newBalance = result.balance;
        var _result_allBadges;
        const allBadges = (_result_allBadges = result.allBadges) !== null && _result_allBadges !== void 0 ? _result_allBadges : [];
        yield put(awardBadgeSuccess(result.badge, recipient, newBalance, allBadges));
    } else {
        yield put(awardBadgeFail(badgeType, recipient, result.errorDescription || i18next.t('common.somethingWentWrong')));
    }
}
function* handleAwardBadgeSuccess(action) {
    const { badge, recipient } = action.payload;
    const notification = {
        badge,
        recipient
    };
    const isMobile = yield select(getIsMobile);
    yield put(addNotificationToQueue(getBadgeNotificationQueue(recipient, isMobile), NotificationType.Badge, notification));
}
/** returns proper queuename based on what's being awarded a badge */ function getBadgeNotificationQueue(recipient, isMobile) {
    if (isMobile) {
        return 'default';
    }
    if (DeviationResourceType[recipient.typeId]) {
        // It's not especially pretty, but the queue only needs type and id
        return getDeviationNotificationQueue({
            typeId: recipient.typeId,
            deviationId: recipient.itemId
        });
    }
    if (recipient.typeId === ResourceType.COMMENT) {
        return getCommentNotificationQueue({
            commentId: recipient.itemId
        });
    }
    return 'default';
}
function* handleFetchAvailableBadges(action) {
    const { userId, typeId, itemId } = action.payload;
    const params = {
        userid: userId,
        typeid: typeId,
        itemid: itemId
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'corebadge/available_badges',
        params
    });
    if (result) {
        yield put(fetchAvailableBadgesSuccess(userId, result.results));
    }
}
function* handleStreamFetch(action) {
    const { streamId } = action.payload;
    const streamParams = yield select(streamSelectors.getStreamParams, streamId);
    const { offset, limit } = yield select((state)=>({
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: streamSelectors.getItemsPerFetch(state, streamId)
        }));
    const recipient = streamParams.recipient;
    const params = {
        badgetype: streamParams.type,
        typeid: recipient.typeId,
        itemid: recipient.itemId,
        userid: recipient.user.userId,
        offset,
        limit
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'corebadge/givers',
        params
    }, getFakeStreamData);
    if (result) {
        const { hasMore, nextOffset, results } = result;
        yield all([
            ...results.map((user)=>{
                var _user_isWatching;
                return put(setWatchingState(user.username, (_user_isWatching = user.isWatching) !== null && _user_isWatching !== void 0 ? _user_isWatching : false));
            }),
            put(withOffset.actions.fetchSuccess({
                streamId,
                hasMore: !!hasMore,
                nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                items: results
            }))
        ]);
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(awardBadge, handleAwardBadge),
        takeEvery(awardBadgeSuccess, handleAwardBadgeSuccess),
        takeEvery(fetchBadgeGiverStreamNext, handleStreamFetch),
        takeEvery(fetchAvailableBadges, handleFetchAvailableBadges)
    ]);
}
